import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import AcquisitionForm from './forms/AcquisitionForm';
import AcquisitionList from './lists/AcquisitionList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import connect from "react-redux/es/connect/connect";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import Invoice from "./OperationList/Elements/Invoice";
import Payment from "./OperationList/Elements/Payment";
import get from "../../utils/get";
import ModalEditor from "./ModalEditor";
import InvoiceEditor from "./invoiceEditor";

class AcquisitionEditor extends React.Component {

    state = {
        proceed: false
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getValue = (name) => {
        return get(this.props.values, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        if (!props.disabled) {
            const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
            props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
            if (this.props[name]) {
                props = {
                    ...this.props[name],
                    ...props,
                    disabled: this.props[name].disabled || props.disabled
                };
            }
        }
        return props;
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || (this.props.values[this.props.componentConfig.idfield] && this.props.values.state + "" !== "0");
        return props;
    }

    proceed = async () => {
        if (this.state.proceed === false) {
            this.setState({proceed: {}});
            return false;
        }
        const values = await referenceActionData(this.props.values, this.props.componentConfig);
        delete values.items;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceed',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
                this.setState({proceed: false});
            }
            return response;
        });
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Beszerzések"
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <AcquisitionList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Beszerzés"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Fragment key="1">
                            <Modal
                                state={this.state.proceed instanceof Object ? "on" : "off"}
                                theme="default"
                                size="large"
                                header="Biztos mehet?"
                                buttons={[
                                    {
                                        text: 'Mégse',
                                        props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                        onClose: true,
                                        onClick: async () => {
                                            try {
                                                this.setState({proceed: false});
                                            } catch (e) {

                                            }
                                        }
                                    },
                                    {
                                        text: 'Mehet',
                                        props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                        onClick: async () => {
                                            await this.proceed();
                                        }
                                    }
                                ]}
                            >
                                <Invoice props={{values: this.props.values, getProps: (name) => this.getProps(name), getValue: (name) => this.getValue(name), setFieldValue: (field, value) => this.props.setFieldValue(field, value)}} default="seller"/>
                                <div className="row">
                                    <Payment props={{values: this.props.values, getFieldProps: this.getProps, getProps: this.getProps, getValue: this.getValue, setFieldValue: this.props.setFieldValue}} />
                                </div>
                            </Modal>
                            <Button
                                disabled={this.props.isLoading || !this.props.values[this.props.componentConfig.idfield] || this.props.values[this.props.componentConfig.idfield] && parseInt(this.props.values.state || "0") > 0}
                                color="primary"
                                className="pull-right"
                                onClick={this.proceed}
                            >
                                Véglegesítés
                            </Button>
                        </Fragment>,
                    ]}
                >
                    <AcquisitionForm {...this.props} getFieldProps={this.getFieldProps} />
                </Editor>
                <Other>
                    {this.props.values[this.props.componentConfig.idfield] && <InvoiceEditor
                        editorContext="acquisitionInvoiceEditor"
                        gridid="acquisitionInvoiceList"
                        pageSize={0}
                        listFilter={[
                            {
                                field: "component",
                                value: this.props.componentConfig.componentname
                            },{
                                field: "component_id",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                        editor={ModalEditor}
                        selection={null}
                        onProcessAction={() => {
                            if (!this.props.isLoading) {
                                this.props.reloadForm && this.props.reloadForm();
                            }
                        }}
                    />}
                </Other>
        </Fragment>;
    }
}

const Editor = (props) => {
    if (!props.pos) {
        return <Box header="Hiba" theme="danger">
            Kérlek jelentkezz be egy eladási helyre!
        </Box>;
    }
    const Editor = createEditor({
        componentName: "Acquisition",
        WrappedComponent: AcquisitionEditor,
        props: {
            view: "admin",
            componentActions: async (action, data, params, componentConfig) => {
                data = await referenceActionData(data, componentConfig);
                return {action, data, params};
            }
        }
    });
    props = {...props};
    props.presets = {
        customer: props.pos.partner,
    }
    return <Editor {...props} />
};

export default connect((state) => {
    return {
        pos: state.app.till.pos
    };
}, {})(Editor);
